import { ACTION, OWNERSHIP_CLAIM_LISTENER, OWNERSHIP_CLAIM } from '../../../common/const/lei-products';

// Display-only label; not a submission type, so it is not part of ACTION.
const CLAIM = 'CLAIM';

/** True when the submission's work payload carries the ownership-claim marker. */
export function isOwnershipClaim(submission) {
  let workPayload = submission && submission.workPayload;
  if (typeof workPayload === 'string') {
    try {
      workPayload = JSON.parse(workPayload);
    } catch (e) {
      return false;
    }
  }
  return Boolean(
    workPayload && workPayload.metadata && workPayload.metadata[OWNERSHIP_CLAIM_LISTENER] === OWNERSHIP_CLAIM
  );
}

/** The action to label a submission with: CLAIM / CLAIM_RENEW for claims, otherwise its type. */
export function submissionDisplayType(submission) {
  const type = (submission && submission.type) || '';
  if (!isOwnershipClaim(submission)) {
    return type;
  }
  if (type === ACTION.UPDATE) {
    return CLAIM;
  }
  if (type === ACTION.RENEW) {
    return ACTION.CLAIMRENEW;
  }
  return type;
}
